export enum RoleEnum {
  ADMIN = 'ROLE_ADMIN', OPERATOR = 'ROLE_OPERADOR', AUDITOR = 'ROLE_AUDITOR'
}
